import { onMounted, computed, ref, onBeforeUnmount, type Ref } from 'vue';

export function useBreakpoints() {
  const resizeObserver = ref() as Ref<ResizeObserver>;
  const width = ref(typeof window !== 'undefined' ? window.innerWidth : 1920);

  const breakpoints = computed(() => {
    return {
      xsm: width.value < 576,
      sm: width.value > 576,
      md: width.value > 768,
      lg: width.value > 992,
      xl: width.value > 1200,
      xxl: width.value > 1400,
    };
  });

  function onResize(entries: ResizeObserverEntry[]) {
    for (const entry of entries) {
      if (entry.contentRect && entry.contentRect.width !== width.value) {
        width.value = entry.contentRect.width;
      }
    }
  }

  onMounted(() => {
    width.value = window.innerWidth;
    resizeObserver.value = new ResizeObserver(onResize);

    resizeObserver.value.observe(document.body);
  });

  onBeforeUnmount(() => {
    if (resizeObserver.value) {
      resizeObserver.value.disconnect();
    }
  });

  return breakpoints;
}
